export const ThemeConst = {
  CONSUMER_LIGHTGREY: '#f2f2f7',
  APPLE_RED: 'rgba(255, 59, 48, 1)',
  APPLE_ORANGE: 'rgba(255, 149, 0, 1)',
  APPLE_YELLOW: 'rgba(255, 204, 0, 1)',
  APPLE_GREEN: 'rgba(52, 199, 89, 1)',
  APPLE_GREEN_MEDIUM: 'rgba(52, 199, 89, 0.5)',
  APPLE_GREEN_LIGHT: 'rgba(52, 199, 89, 0.1)',
  APPLE_CYAN: 'rgba(50, 173, 230, 1)',
  APPLE_BLUE: 'rgba(0, 122, 255, 1)',
  APPLE_INDIGO: 'rgba(88, 86, 214, 1)',
  APPLE_PURPLE: 'rgba(175, 82, 222, 1)',
  APPLE_GREY: 'rgba(142, 142, 147, 1)',

  PRIMARY_YELLOW: 'rgba(255, 204, 0, 1)',
  // PRIMARY_YELLOW: '#FBCC00',
}
